module.exports = __webpack_public_path__ + "static/media/YF45_0.5832c362.jpg";